import { render, staticRenderFns } from "./list_side.vue?vue&type=template&id=7b374fb6"
import script from "./list_side.vue?vue&type=script&lang=js"
export * from "./list_side.vue?vue&type=script&lang=js"
import style0 from "./list_side.vue?vue&type=style&index=0&id=7b374fb6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports